import React from 'react';
import { motion } from 'framer-motion';
export const pageVariants = {
  initial: {
    opacity: 0,
    y: 12
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: [0.22, 1, 0.36, 1]
    }
  },
  exit: {
    opacity: 0,
    y: -8,
    transition: {
      duration: 0.25,
      ease: [0.4, 0, 1, 1]
    }
  }
};
const sectionVariants = {
  initial: {
    opacity: 0,
    y: 28
  },
  whileInView: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
// Wraps an entire route/page. Provides a soft fade + rise entrance,
// and a quick fade + rise exit when navigating away.
export function PageWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  return <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" data-id="element-331">
      {children}
    </motion.div>;
}
// Wraps a section within a page. Reveals once, as it scrolls into view.
export function SectionWrapper({
  children,
  className,
  delay = 0
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) {
  return <motion.div initial={sectionVariants.initial} whileInView={sectionVariants.whileInView} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-332">
      {children}
    </motion.div>;
}